import { PayloadAction, createSlice } from "@reduxjs/toolkit";

interface TemplateChanges {
  showModalCreateTemplate: boolean;
}
const initialState: TemplateChanges = {
  showModalCreateTemplate: false
};

const templateSlice = createSlice({
  name: "templates",
  initialState,
  reducers: {
    setShowModalCreateTemplate(state, action: PayloadAction<boolean>) {
      state.showModalCreateTemplate = action.payload;
    }
  }
});

export const { setShowModalCreateTemplate } = templateSlice.actions;

export default templateSlice.reducer;
